import script from "./LevelTwo.vue?vue&type=script&lang=js"
export * from "./LevelTwo.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__